<template>
    <div>
        <el-card>
            <div slot="header" class="flex flex-between flex-v-center">
                <h3>{{ $t('我的作业') }}</h3>
            </div>
            <div style="padding: 0 10px;">
                <el-tabs v-model="status" @tab-click="query()">
                    <el-tab-pane v-for="(t, i) in tabs" :key="i" :label="$t(t) + '(' + counts[i] + ')'"
                        :name="i"></el-tab-pane>
                </el-tabs>
            </div>
            <div v-loading="loading == 'list'" class="margin-t" v-if="list.length > 0">
                <div v-for="(item, index1) in list" :key="index1" @click="to1(item)"
                    :class="{ 'bb': index1 < list.length - 1 }" class="mock-item on">
                    <div class="flex flex-between flex-v-center" style="height:100%">

                        <div>
                            <h5>
                                <el-tag class="margin-r">{{ item.clazz_name }}</el-tag>
                                {{ item.title }}
                            </h5>


                            <div class="flex flex-v-center margin-t">

                                <div style="font-size: 12px;gap:" class="flex flex-v-center">{{ $t('布置老师')
                                }}： <el-avatar class="margin-r" size="small" :src="item.teacher.avatar"></el-avatar>
                                    {{
                                        item.teacher.name }}</div>

                                <div style="font-size: 12px;margin-left:40px;">{{ status == 0 ? $t('布置时间') : $t('提交时间')
                                }}：{{
                                        status == 0 ? item.created_at : item.user_time }}</div>

                                <div style="font-size: 12px;margin-left:40px;">{{ $t('过期时间')
                                }}：{{
                                        item.expiry_time }}</div>

                            </div>
                        </div>
                        <div class="flex flex-v-center">
                            <h5 v-if="item.status == 0">【{{ $t('未提交') }}】</h5>
                            <h5 v-else-if="item.status == 1">【{{ $t('待批改') }}】</h5>
                            <h5 v-else-if="item.status == 2">【{{ $t('已批改') }}】</h5>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
            </div>
            <el-empty v-loading="loading == 'list'" v-else></el-empty>
        </el-card>



        <el-dialog @close="record_close()" fullscreen v-if="record" custom-class="br" :visible.sync="dalogVisible"
            :close-on-click-modal="false" :show-close="false" width="50%" center>
            <h4 slot="title">{{ workItem.title }} - {{ tabs[status] }}</h4>

            <el-card shadow="never">
                <el-form ref="form" label-position="left" :model="form" label-width="120px">

                    <el-form-item prop="content">
                        <h4 slot="label">{{ $t('作业内容') }}</h4>
                        <div>{{ record.work.content }}</div>
                        <div v-for="(item1, i) in record.work.attachment" :key="i">
                            <el-divider></el-divider>
                            <div class="flex flex-between flex-v-center">
                                <audio controls v-if="item1.type == 'audio'" :src="$host + item1.url"></audio>
                                <el-image :preview-src-list="[$host + item1.url]" v-else-if="item1.type == 'image'"
                                    style="height: 100px;width: 200px;" fit="cover" :src="$host + item1.url"></el-image>
                                <el-link v-else-if="item1.type == 'file'">{{ item1.url.split('/').pop()
                                    }}</el-link>

                                <div class="flex flex-v-center">
                                    <el-tooltip :content="$t('下载')">
                                        <el-button @click="remove_attachment(i)" style="font-size: 25px;" type="text"
                                            icon="el-icon-download"></el-button>
                                    </el-tooltip>
                                </div>
                            </div>

                        </div>
                    </el-form-item>



                    <el-divider></el-divider>
                    <el-form-item prop="content">
                        <h4 slot="label">{{ $t('已添加作业') }}</h4>

                        <div>
                            <div class="flex" style="justify-content: flex-end;" v-if="record.status == 0">
                                <el-button @click="toPractise()" round type="primary">{{ $t('去添加作业') }}<i
                                        class="el-icon-right"></i></el-button>
                            </div>
                            <div v-if="record.records && record.records.length > 0">
                                <record-list :homework-index="index" :tag="item.source.tag"
                                    v-for="(item, index) in record.records" :answer="item.source.answer" :key="item.id"
                                    homework @homeworkDelete="homeworkDelete" :list="[item]"
                                    :deleteable="record.status == 0">
                                    <div slot="append" :key="item.id" v-if="item.result" class="margin-t padding"
                                        style="background-color: #f5f5f5;border-radius: 10px;">
                                        <div class="flex flex-v-center">
                                            <el-avatar :src="item.result.teacher.avatar"></el-avatar>

                                            <div class="margin-l" style="line-height:24px;">
                                                <h4>{{ item.result.teacher.name }}</h4>
                                                <div style="color:#999">{{ item.result.time }}</div>
                                            </div>
                                        </div>

                                        <div>
                                            <el-tag size="small">{{ item.result.pass ? $t('达标') : $t('不达标') }}</el-tag>
                                            <span class="margin-l">{{ item.result.content }}</span>
                                        </div>
                                        <div v-for="(item, i) in item.result.attachment" :key="i" class="margin-ts">
                                            <div class="flex flex-between flex-v-center">
                                                <audio v-if="item.type == 'audio'" controls
                                                    :src="$host + item.url"></audio>
                                                <el-image :preview-src-list="[$host + item.url]"
                                                    v-else-if="item.type == 'image'" style="height: 100px;width: 200px;"
                                                    fit="cover" :src="$host + item.url"></el-image>
                                                <el-link v-else-if="item.type == 'file'">{{
                                                    item.url.split('/').pop()
                                                }}</el-link>

                                                <div class="flex flex-v-center" v-if="record.status == 0">
                                                    <el-tooltip :content="$t('下载')">
                                                        <el-button @click="open_attachment(i)" style="font-size: 25px;"
                                                            type="text" icon="el-icon-download"></el-button>
                                                    </el-tooltip>
                                                    <el-tooltip :content="$t('移除')">
                                                        <el-button @click="remove_attachment(i)"
                                                            style="font-size: 25px;" type="text"
                                                            icon="el-icon-close"></el-button>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </record-list>
                            </div>
                            <el-empty :description="$t('还没添加练习到作业中')" v-else></el-empty>
                        </div>

                    </el-form-item>

                    <el-divider></el-divider>

                    <el-form-item prop="content">
                        <h4 slot="label">{{record.status == 0 ? $t('给老师留言') : $t('留言内容')}}</h4>
                        <el-input v-if="record.status == 0" type="textarea" autosize
                            :placeholder="status == 0 ? $t('请输入留言内容') : '-'" v-model="form.content.text">
                        </el-input>
                        <div v-else>{{ form.content.text }}</div>

                        <div v-for="(item, i) in form.content.attachment" :key="i">
                            <el-divider></el-divider>
                            <div class="flex flex-between flex-v-center">
                                <template v-if="item.type == 'audio'">
                                    <audio controls v-if="item.url" :src="$host + item.url"></audio>
                                    <audio-recorder v-else :index="i" @start="set_audio_index" @content="set_audio"
                                        :time_limit="120" :submittable="false"></audio-recorder>
                                </template>
                                <el-image :preview-src-list="[$host + item.url]" v-else-if="item.type == 'image'"
                                    style="height: 100px;width: 200px;" fit="cover" :src="$host + item.url"></el-image>
                                <el-link v-else-if="item.type == 'file'">{{ item.url.split('/').pop()
                                    }}</el-link>

                                <div class="flex flex-v-center" v-if="record.status == 0">
                                    <el-tooltip :content="$t('下载')">
                                        <el-button @click="open_attachment(i)" style="font-size: 25px;" type="text"
                                            icon="el-icon-download"></el-button>
                                    </el-tooltip>
                                    <el-tooltip :content="$t('移除')">
                                        <el-button @click="remove_attachment(i)" style="font-size: 25px;" type="text"
                                            icon="el-icon-close"></el-button>
                                    </el-tooltip>
                                </div>
                            </div>

                        </div>


                        <div class="flex flex-v-center margin-ts" v-if="record.status == 0">
                            <el-button style="font-size: 16px;" @click="add_audio()" type="text" size="large"
                                icon="el-icon-service">{{
                                    $t('添加音频') }}</el-button>

                            <el-divider class="margin-x" direction="vertical"></el-divider>
                            <el-upload accept="image/jpeg,image/jpg,image/png" :headers="headers" :action="action"
                                :show-file-list="false" :on-success="handleImageSuccess">
                                <el-button style="font-size: 16px;" type="text" size="large" icon="el-icon-picture">{{
                                    $t('添加图片') }}</el-button>
                            </el-upload>
                        </div>

                    </el-form-item>
                </el-form>
            </el-card>


            <span class="dialog-footer center" slot="footer">
                <el-button icon="el-icon-close" @click="dalogVisible = false">{{ $t('关 闭') }}</el-button>

                <el-button :loading="loading == 'submit'" icon="el-icon-check" class="margin-l" type="primary"
                    v-if="record.status == 0" @click="submit()"
                    :disabled="!record.records || record.records.length == 0">{{
                        $t('提交作业') }}</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import AudioRecorder from '../../components/AudioRecorder.vue';
import RecordList from '../../components/RecordList.vue';
import getWFD from '../../util/index.js';
export default {
    components: { AudioRecorder, RecordList },
    data() {
        return {
            tabs: ['待提交', '待批改', '已批改'],
            action: 'https://www.ptefighter.com/api/work/upload',
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            counts: [0, 0, 0],
            audio: false,
            status: '0',
            list: [],
            workItem: null,
            record: null,
            form: { id: 0, content: { attachment: [], text: '' } },
            dalogVisible: false,
            loading: null,
            audio_index: -1
        };
    },

    computed: {

    },



    created() {
        this.get_counts()
        this.query();
    },

    methods: {
        record_close() {
            if (this.form.content.attachment.length > 0) {
                const urls = this.form.content.attachment.filter(v => v.is_new).map(v => v.url)
                if (urls.length > 0) {
                    this.$http.post("/api/work/upload/remove", { urls })
                }
            }
        },

        remove_attachment(i) {
            if (!this.form.content.attachment[i].url) {
                this.form.content.attachment.splice(i, 1)
                return
            }
            if (this.form.content.attachment[i].is_new) {
                const urls = [this.form.content.attachment[i].url]
                this.$http.post("/api/work/upload/remove", { urls }).then(() => {
                    this.form.content.attachment.splice(i, 1)
                })
            }
        },

        toPractise() {
            this.dalogVisible = false
            this.$router.push('/main/practise')
        },

        handleImageSuccess(url) {
            this.form.content.attachment.push({
                type: 'image',
                url,
                is_new: 1
            })
        },

        set_audio_index(i) {
            this.audio_index = i
        },

        set_audio(file) {
            this.form.content.attachment[this.audio_index].file = file
        },

        homeworkDelete(id) {
            this.$http.post('/api/homework/record/id', { work_id: this.record.work_id, record_id: id }).then(() => {
                const index = this.record.records.findIndex(v => v.id == id)
                this.record.records.splice(index, 1)
            })
        },

        add_audio() {
            this.form.content.attachment.push({
                type: 'audio'
            })
        },
        async submit() {
            this.loading = 'submit'
            for (let i = 0; i < this.form.content.attachment.length; i++) {
                if (this.form.content.attachment[i].file) {
                    let formData = new FormData();
                    formData.append("file", this.form.content.attachment[i].file);
                    const url = await this.$http.post('/api/work/upload', formData, {
                        timeout: 60000,
                        headers: {
                            'Content-type': 'multipart/form-data'
                        }
                    })
                    this.form.content.attachment[i].url = url
                    delete this.form.content.attachment[i].file
                }
                delete this.form.content.attachment[i].is_new
            }
            this.form.id = this.record.id
            this.$http.post("/api/homework/record", this.form).then(() => {
                this.get_counts()
                this.query()
                this.form.content.attachment = []
                this.dalogVisible = false
                this.loading = null
            })
        },
        setContent(e) {
            this.form.file = e
        },

        get_counts() {
            this.$http.post("/api/homework/counts").then((counts) => {
                this.counts = counts
            })
        },
        query() {
            this.loading = 'list'

            this.$http.post("/api/homework/list", { status: this.status }).then((list) => {
                this.list = list;
                this.loading = null
            })
        },

        to1(item) {
            this.workItem = item;
            this.$http.post("/api/homework/record/info", { id: item.id }).then((record) => {
                if (record.records) {
                    record.records.forEach(item => {
                        if (item.content == null) {
                            item.content = "";
                            item.height = 0;
                        }
                        if (item.content && item.source.tag == 'WFD') {
                            item.contents = getWFD(item.source.answer, item.content);
                        }
                    });
                }
                this.record = record;
                if (this.record.status > 0) {
                    this.form.content = this.record.content
                } else {
                    this.form.content = { attachment: [], text: '' }
                }
                this.dalogVisible = true;
            })
        },

        remove(item) {
            this.$confirm('', this.$t('确认删除此模考记录') + '?', {
                center: true,
                confirmButtonText: this.$t('确定'),
                cancelButtonText: this.$t('取消'),
                type: 'primary'
            }).then(() => {
                this.$http.post("/api/mock/record/remove", { id: item.id }).then(() => {
                    this.query();
                })
            });
        },

    },
};
</script>

<style scoped>
.mock-item {
    cursor: pointer;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
}

.mock-item.bb {
    margin-bottom: 15px;
}

.mock-item:hover,
.mock-item.on {
    border: 1px solid #e6a13c;
    color: #e6a13c;
}
</style>
